var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoDataDescription = function SvgNoDataDescription(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.5.3.13.1-Setup-/-Company-/-Create-new-project-/-Step-3-/-View-package---general-information-no-description",
    transform: "translate(-681.000000, -470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/04.Confirmation/Empty-state",
    transform: "translate(569.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F1F1",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "01.Icon/01.Basic/Fill/24/calendar-clear",
    transform: "translate(26.458333, 30.625000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0416668,0.520833336 C26.9046117,0.520833336 27.6041668,1.22038842 27.6041668,2.08333334 C27.6041668,2.94627827 26.9046117,3.64583335 26.0416668,3.64583335 L7.2916667,3.64583335 C6.42872178,3.64583335 5.7291667,2.94627827 5.7291667,2.08333334 C5.7291667,1.22038842 6.42872178,0.520833336 7.2916667,0.520833336 L26.0416668,0.520833336 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0416668,7.81250004 C26.9046117,7.81250004 27.6041668,8.51205512 27.6041668,9.37500005 C27.6041668,10.237945 26.9046117,10.9375001 26.0416668,10.9375001 L7.2916667,10.9375001 C6.42872178,10.9375001 5.7291667,10.237945 5.7291667,9.37500005 C5.7291667,8.51205512 6.42872178,7.81250004 7.2916667,7.81250004 L26.0416668,7.81250004 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0416668,15.1041667 C26.9046117,15.1041667 27.6041668,15.8037218 27.6041668,16.6666667 C27.6041668,17.5296117 26.9046117,18.2291668 26.0416668,18.2291668 L7.2916667,18.2291668 C6.42872178,18.2291668 5.7291667,17.5296117 5.7291667,16.6666667 C5.7291667,15.8037218 6.42872178,15.1041667 7.2916667,15.1041667 L26.0416668,15.1041667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08333334,0 C3.23392658,0 4.16666669,0.932740109 4.16666669,2.08333334 C4.16666669,3.23392658 3.23392658,4.16666669 2.08333334,4.16666669 C0.932740109,4.16666669 0,3.23392658 0,2.08333334 C0,0.932740109 0.932740109,0 2.08333334,0 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08333334,7.2916667 C3.23392658,7.2916667 4.16666669,8.22440681 4.16666669,9.37500005 C4.16666669,10.5255933 3.23392658,11.4583334 2.08333334,11.4583334 C0.932740109,11.4583334 0,10.5255933 0,9.37500005 C0,8.22440681 0.932740109,7.2916667 2.08333334,7.2916667 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08333334,14.5833334 C3.23392658,14.5833334 4.16666669,15.5160735 4.16666669,16.6666667 C4.16666669,17.81726 3.23392658,18.7500001 2.08333334,18.7500001 C0.932740109,18.7500001 0,17.81726 0,16.6666667 C0,15.5160735 0.932740109,14.5833334 2.08333334,14.5833334 Z",
    id: "Oval"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoDataDescription, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data-description.ba38e34a.svg";
export { ForwardRef as ReactComponent };